<template>
  <div class="ma-1 ma-sm-4">
    <v-card flat class="blueCard">
      <div class="pa-2">
        <div class="d-flex flex-row flex-wrap align-center">
          <div class="text-h5 mr-4">Refractive Error Simulator</div>
          <rx-paster
            :noAdd="true"
            :noDominant="true"
            @pasted="pasted($event)"
            buttonText="Parse from Text"
            :params="['small', 'block']"
            buttonColor="#FFF"
            :imageIcon="true"
            :types="['rx']"
          >
          </rx-paster>
          <v-spacer></v-spacer>
          <div class="caption">
            <a href="/documentation/refractive-error-simulator"
              >Documentation

              <v-icon x-small color="primary" class="mx-1"
                >mdi-open-in-new</v-icon
              ></a
            >
          </div>
          <!-- <v-spacer></v-spacer> -->
          <!-- <vs-template-picker
            @templateSelected="templateSelected($event)"
          ></vs-template-picker> -->
        </div>
        <!-- <v-spacer></v-spacer> -->
        <div class="d-flex flex-row flex-wrap align-center">
          <!-- <div class="d-flex flex-row justify-end mt-1">
            <div class="caption"> -->
          <!-- Cyl Type -->
          <div class="mr-4 my-2">
            <v-btn-toggle
              v-model="cylinderType"
              :mandatory="true"
              rounded
              class="toggleBtns ml-1 d-print-none"
              active-class="orangeActive"
            >
              <v-btn :value="-1" x-small>Minus Cyl</v-btn>
              <v-btn :value="1" x-small>Plus Cyl</v-btn>
            </v-btn-toggle>
          </div>
          <!-- <div class="mr-4 my-2">
            <v-btn-toggle
              v-model="metric"
              :mandatory="true"
              rounded
              class="toggleBtns ml-1 d-print-none"
              active-class="orangeActive"
            >
              <v-btn :value="false" x-small>Imperial</v-btn>
              <v-btn :value="true" x-small>Metric</v-btn>
            </v-btn-toggle>
          </div> -->
          <div class="mr-6 my-2">
            <v-btn-toggle
              v-model="eyes"
              :mandatory="true"
              rounded
              class="toggleBtns ml-1 d-print-none"
              active-class="orangeActive"
            >
              <v-btn :value="['od']" x-small>OD</v-btn>
              <v-btn :value="['os']" x-small>OS</v-btn>
              <v-btn :value="['od', 'os']" x-small>OU</v-btn>
            </v-btn-toggle>
          </div>

          <looking-at-selector
            class=""
            :metric="metric"
            @focusItems="focusItems = $event"
          ></looking-at-selector>
          <!-- </div> -->
          <!-- </div> -->
          <!-- <div class="d-flex flex-row justify-end mt-2"> -->
          <!-- <div class="caption">Eyes</div> -->

          <!-- </div> -->
          <!-- <v-expand-transition>
            <div
              v-if="!oneEye"
              class="d-flex flex-row align-center caption d-print-none"
            >
              <v-checkbox
                v-model="yokedAccommodation"
                :disabled="oneEye"
                label="Yoked Accommodation"
                dense
                :hide-details="true"
                class="mr-3"
              ></v-checkbox>
              <simple-popover title="Yoked Accommodation" class="">
                <template #content>
                  <div v-html="VsDefinitions.yokesAccomDef"></div
                ></template>
              </simple-popover>
            </div>
          </v-expand-transition> -->
        </div>
      </div>
    </v-card>

    <div class="my-5">
      <!-- <div class="overline">Refraction</div> -->
      <div class="d-flex flex-row flex-wrap justify-space-between">
        <v-card
          v-for="eye in eyes"
          :key="eye"
          flat
          :class="[
            eye + 'Background',
            eye + 'Border',

            eyes.length == 1 || isMobile ? 'width100p' : 'eyeSection',
          ]"
          class="px-4 mb-2"
        >
          <div class="d-flex flex-row align-center">
            <div class="title">{{ eye | eyeText }} Eye Rx</div>
            <v-spacer></v-spacer>
          </div>
          <div class="d-flex flex-row align-start">
            <div style="min-width: 70%; width: 350px; max-width: 100%">
              <div class="d-flex flex-row align-center">
                <div>
                  <div class="d-none d-print-inline-block">
                    Sphere:
                    {{ numToDiopterString(-rxInputs[eye].sph, 1) }}
                    <span class="mx-2"></span>
                    Cylinder:
                    {{
                      numToDiopterString(cylinderType * rxInputs[eye].cyl, 1)
                    }}
                  </div>
                </div>
                <!-- <v-spacer></v-spacer>
                <v-checkbox :hide-details="false">chbx</v-checkbox> -->
              </div>

              <div class="d-flex flex-row align-center d-print-none">
                <div class="d-flex flex-row align-center">
                  <div style="min-width: 56px" class="sliderLabel">
                    {{ numToDiopterString(-rxInputs[eye].sph, 1) }}
                  </div>
                  <span class="mr-2 caption">Sph</span>
                </div>
                <v-slider
                  class="sliderElement"
                  v-model="rxInputs[eye].sph"
                  min="-10.0"
                  max="10"
                  step=".25"
                  dense
                  :hide-details="true"
                  thumb-label
                  :thumb-color="rxs[eye].sph < 0 ? 'red' : 'green'"
                  @mousedown="ageSliding = true"
                  @mouseup="ageSliding = false"
                >
                  <template v-slot:thumb-label="{ value }">
                    {{ numToDiopterString(-value, 1) }}
                  </template>
                </v-slider>
              </div>
              <div class="d-flex flex-row align-center d-print-none mb-2">
                <div class="d-flex flex-row align-center">
                  <div style="min-width: 56px" class="sliderLabel">
                    {{
                      numToDiopterString(cylinderType * rxInputs[eye].cyl, 1)
                    }}
                  </div>
                  <span class="mr-2 caption">Cyl</span>
                </div>
                <v-slider
                  class="sliderElement"
                  v-model="rxInputs[eye].cyl"
                  min="0"
                  max="6"
                  step=".25"
                  dense
                  :hide-details="true"
                  thumb-label
                  @mousedown="ageSliding = true"
                  @mouseup="ageSliding = false"
                >
                  <template v-slot:thumb-label="{ value }">
                    {{ numToDiopterString(cylinderType * value, 1) }}
                  </template>
                </v-slider>
              </div>
            </div>

            <div style="min-width: 70px" v-if="!isMobile">
              <optical-cross-image
                :dimensions="55"
                :obj="rxs[eye]"
                :showMeridianLabels="false"
                labelFontSize="7"
                type="refraction"
                style="margin-top: -43px"
              />
            </div>
          </div>
        </v-card>
      </div>

      <v-card
        flat
        class="ageDiv px-4 py-2 d-flex flex-row flex-wrap align-center"
      >
        <div class="font-weight-medium labelWidth">Age</div>

        <div style="min-width: 55px" class="mr-1 text-center">
          {{ ageDescription }}
        </div>
        <!-- {{ ageSliding }} -->
        <div class="d-none d-print-flex">{{ accomDescription }}</div>
        <div style="min-width: 250px">
          <v-slider
            v-model="age"
            min="35"
            max="61"
            @input="ageChange()"
            @mousedown="ageSliding = true"
            @mouseup="ageSliding = false"
            :hide-details="true"
            dense
            class="d-print-none mr-8"
          ></v-slider>
        </div>
        <div class="caption d-flex flex-row align-center d-print-none mr-2">
          <div class="mr-2" style="">Available Accommodation (focusing)</div>
          <div :style="'min-width: ' + (isMobile ? 100 : 200) + 'px;'">
            <v-progress-linear
              :value="accomAbility * 17"
              height="6"
              color="#90CAF9"
              rounded
            ></v-progress-linear>
          </div>
          <!-- <simple-popover title="Age & Accommodation" class="ml-3">
            <template #content>
              <div v-html="VsDefinitions.accommodationDef"></div>
            </template>
          </simple-popover> -->
        </div>
      </v-card>
    </div>

    <div v-for="id in scenarioRows" :key="id" class="mb-6">
      <vs-scenario-row
        :rxs="rxs"
        :eyes="eyes"
        :yokedAccommodation="yokedAccommodation && !oneEye"
        :templateData="scenarioRowForTemplate[id]"
        :metric="metric"
        :accomAbility="accomAbilityIfNotUpdating"
        :focusItems="focusItems"
      >
        <!--  -->
        <v-btn
          v-if="scenarioRows.length > 1"
          @click="removeScenarioRow(id)"
          small
          depressed
          icon
          class="d-print-none pa-1"
          ><v-icon color="red" small>mdi-close</v-icon>
        </v-btn>
      </vs-scenario-row>
    </div>

    <!-- </transition-group> -->

    <!-- <div class="caption d-print-none" v-if="!isPhone">
      (Click an image to focus at a different distance)
    </div> -->

    <!-- <div class="d-flex flex-row d-print-none">
      <v-spacer></v-spacer>
      <v-btn @click="addScenarioRow()" rounded depressed
        ><v-icon color="green" class="mr-2">mdi-plus-circle</v-icon> Add a
        scenario</v-btn
      >
    </div> -->

    <v-alert dense outlined type="info" class="mt-4">
      <div class="overline">General Info</div>
      <ul class="caption">
        <li v-for="li in VsDefinitions.generalInfo" :key="li" v-html="li"></li>
      </ul>

      <dialog-lightbox
        :imagePath="edImagespath"
        :images="edImages"
        :iconHeight="200"
        :iconWidth="200"
        :canShowQuickCalcs="false"
        :fullscreen="false"
        :maxDialogWidth="800"
      ></dialog-lightbox>
    </v-alert>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import VsScenarioRow from "./VsScenarioRow.vue";
import LookingAtSelector from "./LookingAtSelector.vue";
import VsDefinitions from "./VsDefinitions";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import RxPaster from "@/components/clStuff/RxPaster.vue";
// import SimplePopover from "@/components/universalStuff/SimplePopover.vue";
import DialogLightbox from "@/components/universalStuff/DialogLightbox";

export default {
  name: "VisionSimulator",
  components: {
    VsScenarioRow,
    LookingAtSelector,
    // SimplePopover,
    DialogLightbox,
    RxPaster,
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
  },
  mixins: [RxMethods, FiltersMixin],
  props: {},
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images/visionSimulator/",
      edImagespath: "https://www.eyedock.com/images/educational_images/",
      edImages: [
        { src: "refractive_error.svg", label: "Refractive Errors" },
        { src: "astigmatism.svg", label: "Astigmatism" },
        { src: "presbyopia.svg", label: "Accommodation & Presbyopia" },
      ],
      // dialog: false,
      cylinderType: -1,
      metric: false,
      rxInputs: { od: { sph: 0, cyl: 0 }, os: { sph: 0, cyl: 0 } }, // note sph sign will be reversed (and maybe cyl too, depending if it's plus or minus cyl)

      accomAbility: 4,
      ageDescription: "",
      accomDescription: " (robust accommodation)",
      age: 35,
      minAge: 35,
      maxAge: 61,
      focusItems: {},
      eyes: ["od"],
      yokedAccommodation: false,
      scenarioRows: [1],
      scenarioRowForTemplate: {},
      maxSphere: 10,
      maxCyl: 6,
      ageSliding: false,
    };
  },
  methods: {
    // just for testing rhe rxPaster!!
    pasted(obj) {
      if (obj.rx) {
        this.setFromExternalRx(obj.rx);
      }
    },
    ageChange() {
      // set accomm ability to a value from 4 to 0 based on age, where 35 is 4 and 61 is 0
      let age = this.age;
      let accom = 0;
      if (age > 40) {
        accom = 4 - (age - 35) / 6;
      } else {
        accom = 5 - (age - 35) / 3; // allow for a little more accommodation at younger ages
      }
      if (accom > 5) accom = 5;
      if (accom < 0) accom = 0;

      this.accomAbility = accom;
      // this.$emit("accomAbilityChange", this.accomAbility);
      let ageText = age; //`${age} y/o`;
      if (age <= this.minAge) ageText = "< 35";
      if (age >= this.maxAge) ageText = "60+";
      this.ageDescription = ageText;
      let desc = " (robust accommodation)";
      if (age >= 40 && age <= 45) desc = " (early presbyopia)";
      if (age >= 46 && age <= 50) desc = " (moderate presbyopia)";
      if (age >= 51 && age <= 55) desc = " (significant presbyopia)";
      if (age >= 56 && age <= 60) desc = " (complete presbyopia)";
      if (age >= 61) desc = " (no accommodation)";
      this.accomDescription = desc;
      // this.$emit("accomDescription", ageText + desc);
    },
    setFromExternalRx(rxs) {
      if (!rxs) return; // if no rx, do nothing
      ["od", "os"].forEach((eye) => {
        if (rxs[eye]) {
          this.rxInputs[eye].sph = -rxs[eye].sph;
          this.rxInputs[eye].cyl = Math.abs(rxs[eye].cyl);
        }
      });
      let isPlusCyl = rxs?.od?.cyl > 0 || rxs?.os?.cyl > 0;
      this.cylinderType = isPlusCyl ? 1 : -1;
    },
  },
  computed: {
    isPhone: function () {
      return this.$vuetify.breakpoint.xs;
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },

    rxs: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let sph = -this.rxInputs[eye].sph; // negative because the slider is reversed
        let cyl = this.rxInputs[eye].cyl * this.cylinderType;
        let rxObject = this.setRxObjectParameters(null, {
          sph: sph,
          cyl: cyl,
        });
        rtn[eye] = rxObject;
      });

      return rtn;
    },
    oneEye: function () {
      return this.eyes.length === 1;
    },
    VsDefinitions: function () {
      return VsDefinitions;
    },
    accomAbilityIfNotUpdating: function () {
      return this.ageSliding ? 0 : this.accomAbility;
    },
  },
  watch: {},
  mounted() {
    let hashParts = this.hashParts();
    let rxObjects = this.rxsFromHash(hashParts);
    this.setFromExternalRx(rxObjects);
    // console.log(rxObjects);
    // if (rxObjects?.od) {
    //   this.rxInputs.od.sph = -rxObjects.od.sph;
    //   this.rxInputs.od.cyl = Math.abs(rxObjects.od.cyl);
    //   this.cylinderType = rxObjects.od.cyl > 0 ? 1 : -1;
    // }
    // if (rxObjects?.os) {
    //   this.rxInputs.os.sph = -rxObjects.os.sph;
    //   this.rxInputs.os.cyl = Math.abs(rxObjects.os.cyl);
    // }
    if (hashParts?.age) {
      this.age = parseInt(hashParts.age);
    }
    this.ageChange();
  },
};
</script>

<style scoped>
.eyeSection {
  min-width: 49%;
  max-width: 0.95vw;
}
.sliderElement >>> .v-label {
  min-width: 90px;
}

.sidewaysText {
  writing-mode: vertical-lr;
  text-orientation: upright;
}
.ageDiv {
  background-color: #fffaed;
  border: 1px solid #cec8b9;
}

.sliderLabel {
  font-size: 14pt;
  font-weight: 400;
  color: #2f2f2f;
}

.fadeLeft-move, /* apply transition to moving elements */
.fadeLeft-enter-active,
.fadeLeft-leave-active {
  transition: all 0.5s ease;
}

.fadeLeft-enter-from,
.fadeLeft-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.fadeLeft-leave-active {
  position: absolute;
}
</style>
